import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = { frame: String, action: String };
  declare readonly frameValue?: string;
  declare readonly hasFrameValue: boolean;
  declare readonly actionValue?: string;
  declare readonly hasActionValue: boolean;

  selectTab(e: Event) {
    const select = e.target as HTMLSelectElement;
    const path = select.value;
    if (!path?.length) return;

    const visitConfig: Record<string, string> = {};
    if (this.hasFrameValue && this.frameValue?.length) visitConfig['frame'] = this.frameValue;
    if (this.hasActionValue && this.actionValue?.length) visitConfig['action'] = this.actionValue;
    Turbo.visit(path, visitConfig);
  }
}
